import { toaster } from "components/common/Toast"
import { loggedOut } from "store/auth"
import { updateGuideAccountStatus, scheduleDeletion, cancelScheduledDeletion, deleteAccount, checkUserDeleteAble } from "store/user"
import { DELETE_ACCOUNT_CONFIRMATION, DELETE_ACCOUNT_UNAVAILABLE, SCHEDULE_DELETION } from "./constants"

const accountActions = {
  handleConfirmByUser: async ({
    dispatch,
    isDeactivateAction,
    password,
    isDeactivated,
    selected,
    scheduledDeletionDate,
    isScheduleDeletion
  }) => {
    try {
      if (isDeactivateAction) {
        const status = isDeactivated ? "activated" : "deactivated"
        const response = await dispatch(updateGuideAccountStatus({ account_status: status, password }))
        if (response?.message) {
          toaster.success(response?.message)
        }
      } else if (scheduledDeletionDate) {
        const response = await dispatch(cancelScheduledDeletion({ password }))
        if (response?.message) {
          toaster.success(response?.message)
        }
      } else if (isScheduleDeletion) {
        const response = await dispatch(scheduleDeletion({ password, stay_active: selected === "active" }))
        if (response?.message) {
          toaster.success(response?.message)
        }
      } else {
        const response = await dispatch(deleteAccount({ password }))
        if (response?.message) {
          toaster.success(response?.message)
        }
        dispatch(loggedOut())
      }
    } catch (error) {
      console.error(error)
    }
  },
  deleteAccountWarning: async ({ dispatch, open, setIsScheduleDeletion }) => {
    const response = await dispatch(checkUserDeleteAble())
    if (response) {
      const { status_code, is_deletable } = response
      // 101 - for pending refund
      if (!is_deletable && status_code === 101) {
        open(DELETE_ACCOUNT_UNAVAILABLE)
        // 103 - for upcoming booking
      } else if (!is_deletable && status_code === 103) {
        open(SCHEDULE_DELETION)
        setIsScheduleDeletion(true)
        // 100 - for success
      } else if (is_deletable && status_code === 100) {
        open(DELETE_ACCOUNT_CONFIRMATION)
      }
    }
  }
}

export { accountActions }
